import stringify from 'json-stable-stringify'
import diff from 'deep-diff'
import { isUtcIsoString } from '../is-utc-iso-string'

export function jsonTryParse(input) {
  if (typeof input === 'string') {
    try {
      const reviver = (key, value) => {
        if (isUtcIsoString(value)) {
          return new Date(value)
        }
        return value
      }

      return JSON.parse(input, reviver)
    } catch (e) {
      return false
    }
  } else {
    return input
  }
}

export function jsonStringify(jsonInput: any, options?: any): string {
  return stringify(jsonInput, options)
}

export function jsonDiff({ dbItem, qbItem }) {
  const updatedFields: any[] = []

  let difference: any = diff(dbItem, qbItem)

  //get only the Edited and Added difference
  difference =
    difference &&
    difference.filter((m) => {
      return m.kind === 'E' || m.kind === 'A' || m.kind === 'N'
    })

  difference?.forEach?.((differenceItem) => {
    let fieldName = differenceItem?.path?.join('.')
    let database = differenceItem.lhs
    let quickbooks = differenceItem.rhs

    if (differenceItem.kind === 'A') {
      if (differenceItem.item) {
        if (differenceItem.item.kind === 'N') {
          database = '<New Item>'
        } else {
          database = differenceItem.item.lhs || ''
        }

        if (differenceItem.item.kind === 'D') {
          quickbooks = '<Deleted Item>'
        } else {
          quickbooks = (differenceItem.item && differenceItem.item.lhs) || ''
        }

        fieldName = `${fieldName}.${differenceItem.index}`
      }
    } else if (differenceItem.kind === 'N') {
      database = '<New Item>'
    }

    updatedFields.push({ fieldName, database, quickbooks })
  })

  return updatedFields
}
